export default __webpack_public_path__ + "static/media/reglogin-bg-ms.aa835eec.webp";